import {defineMessages} from 'react-intl';

/**
 * The definition of messages to be used in the component and available in
 * supported translations. If translation is not available the default message
 * is used.
 */
const messages = defineMessages({
  concertTitle: {
    id: 'Browse.RelatedArtists.concert.title',
    defaultMessage: 'Popular artists near you',
  },
  sportTitle: {
    id: 'Browse.RelatedArtists.sport.title',
    defaultMessage: 'Similar teams',
  },
});

export default messages;
